import axios from "axios";
import { updateLocalStorageItem } from "@/utils/localStorage";

const url = process.env.VUE_APP_XMARTSHELF_ADMINISTRATION;

const state = {
  stores: null,
  selected_store: null,
  available_stores: null,
  loadingStores: false
};

const getters = {
  isLoadingStores(state) {
    return state.loadingStores;
  },
  getAvailableStores(state) {
    return state.available_stores;
  },
  getDefaultStore(state) {
    if (!state.available_stores) return null;

    return state.stores.find((store) => store.default);
  },
  getStores(state) {
    return state.stores;
  },
  getSelectedStore(state) {
    return state.selected_store;
  },
  getDefaultStoreData(state, getters) {
    if (!getters.getStores) return null;
    return getters.getStores.find((store) => store.default);
  }
};

const mutations = {
  setSelectedStore(state, payload) {
    state.selected_store = payload;
    updateLocalStorageItem("xmartshelf_admin", { last_store: payload.id });
  },
  setAvailableStores(state, payload) {
    state.available_stores = payload;
  },
  setStore(state, payload) {
    if (!payload) {
      state.stores = null;
    } else {
      state.stores = state.stores ? [...state.stores, payload] : [payload];
    }
  },
  setLoadingStores(state, status) {
    state.loadingStores = status;
  }
};
const actions = {
  loadStores({ commit, dispatch, getters }) {
    return new Promise((resolve) => {
      const user_id = getters.getUserId;

      if (!user_id) {
        resolve({
          success: false,
          message: "Erro ao carregar dados das lojas."
        });
      }

      const skip = getters.getStores ? getters.getStores.length : 0;

      commit("setLoadingStores", true);

      axios
        .get(`${url}/store/list_stores/user/${user_id}?skip=${skip}`, {
          headers: {
            Authorization: `Bearer ${getters.getSessionToken}`,
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        })
        .then(async (response) => {
          const total = response.data.total;
          const store_list = response.data.stores_list;

          await commit("setAvailableStores", total);
          await dispatch("setStores", store_list);
          await dispatch("setDefaultStore");
          commit("setLoadingStores", false);

          resolve({ success: true, message: "Lojas carregadas com sucesso." });
        })
        .catch((error) => {
          console.error("Erro ao carregar dados das lojas", error);
          commit("setLoadingStores", false);
          resolve({
            success: false,
            message: "Erro ao carregar dados das lojas."
          });
        });
    });
  },
  setStores({ getters, commit }, payload) {
    return new Promise((resolve) => {
      if (payload) {
        for (const store of payload) {
          const alreadyExists = getters.getStores?.some(
            (s) => s.store_id === store.store_id
          );

          if (!alreadyExists) {
            commit("setStore", store);
          }
        }
        resolve();
      } else {
        commit("setStore", null);
        resolve();
      }
    });
  },
  setDefaultStore({ getters, commit }) {
    const data = JSON.parse(localStorage.getItem("xmartshelf_admin") || "{}");
    const last_store = data.last_store;

    const stores = getters.getStores;
    const isLoaded = stores.find((s) => s.store_id === last_store);

    if (isLoaded) {
      commit("setSelectedStore", isLoaded);
    } else {
      const defaultStore = getters.getDefaultStore;
      commit("setSelectedStore", defaultStore);
    }
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
